import React, { useState, useEffect } from "react";
import { HTTP } from "./../api/http-common";
import { Pencil, ArrowUpRightSquareIcon } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabPanel } from "@radix-ui/react-tabs";
import { useGlobalContext } from "./../component/GlobalContext";
import Profile from "../component/Profile"
import ChangePassword from "../component/ChangePassword"
import VendorAddress from "../pages/Vendor/VendorAddress"
import VendorGalleryAdd from "./Vendor/VendorGalleryAdd";
import '../styling/profilePage.css'
import MemberShipCard from "./Member/MemberShipCard";
import MemberShip from "./Member/MemberShip";
import { MemberShipCardStructure } from "../component/ReusableComponents";
function Account() {
  const { globalUserVar } = useGlobalContext();
  // const [memberLogin, setMemberLogin] = useState('');
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [vendorDetail, setVendorDetail] = useState();
  const [selectedTab, setSelectedTab] = useState("profile");
  const { roleId } = useGlobalContext()
  const { userInfo } = useGlobalContext()

  useEffect(() => {
    // console.log(globalUserVar)
    // console.log(typeof(globalUserVar))
    
      // setMemberLogin(`${userInfo.first_name || 'member'} ${userInfo.last_name || ''}`);

    let userData;
    if (typeof (globalUserVar) == 'string') {
      userData = JSON.parse(globalUserVar); // Parse the JSON string
      setName(userData.first_name);
      setLastName(userData.last_name);
      setFullName(`${userData.first_name} ${userData.last_name}`)
      setEmail(userData.email);
      setRole(userData.role.id)
      setVendorDetail(userData.vendor_detail)
    }
  }, [globalUserVar]);

  const renderComponent = () => {
    if (selectedTab === "profile") {
      return <Profile />;
    } else if (selectedTab === "password") {
      return <ChangePassword />;
    } else if (selectedTab === "vendorAddress") {
      return <VendorAddress />;
    } else if (selectedTab === "vendorGallery") {
      return <VendorGalleryAdd />;
    } else if (selectedTab === "membershipCard") {
      
      return(<div className="bg-white rounded-lg p-6 mt-8 pb-0 border-gray-200 "> <MemberShipCardStructure  CardWrapper="family-fun-member-card-member shadow-md" heightContainer="min-h-[300px]" isMemberLogin={fullName}/></div> )
    } else {
      return "";
    }
  };
  return (
    <>
      <div className="container mx-auto p-2 md:p-8 ">
        <div className="bg-white rounded-lg p-6 pb-0 border-gray-200 border min-h-40 flex flex-col justify-between">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center">
                <span className="text-purple-600 text-xl font-semibold">
                  {name.charAt(0)}
                </span>
              </div>
              <div>
                <h3 className="font-semibold text-lg">{name}</h3>
                <p className="text-gray-600 text-sm">{email}</p>
              </div>
            </div>
            {role == "2" && (
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <Link to={`/vendor/details/${vendorDetail.id}`} target="__blank" className="custom-theme-link-button  px-3 py-1.5 flex items-center">
                    <span className="mr-1.5">
                      Details page
                    </span>
                    <ArrowUpRightSquareIcon className='w-4 h-4' />
                  </Link>
                </div>
              </div>
            )}
          </div>


          <Tabs defaultValue={selectedTab} className="TabsRoot">
            <TabsList className="TabsList justify-start gap-6">
              <TabsTrigger
                value="profile"
                className={`text-left justify-start w-0 p-0 TabsTrigger h-[60px] font-medium ${selectedTab === "profile" ? "data-[state=active]" : ""
                  }`}
                onClick={() => setSelectedTab?.("profile")}
              >
                Personal Information
              </TabsTrigger>
              <TabsTrigger
                value="password"
                className={`text-left justify-start w-0 p-0 TabsTrigger h-[60px] font-medium ${selectedTab === "password" ? "data-[state=active]" : ""
                  }`}
                onClick={() => setSelectedTab?.("password")}
              >
                Change Password
              </TabsTrigger>
              {role == '2' ? (
                <TabsTrigger
                  value="vendorAddress"
                  className={`text-left justify-start w-0 p-0 TabsTrigger h-[60px] font-medium ${selectedTab === "vendorAddress" ? "data-[state=active]" : ""
                    }`}
                  onClick={() => setSelectedTab?.("vendorAddress")}
                >
                  Addresses
                </TabsTrigger>
              ) : (
                null
              )}

              {role == '2' ? (
                <TabsTrigger
                  value="vendorGallery"
                  className={`text-left justify-start w-0 p-0 TabsTrigger h-[60px] font-medium ${selectedTab === "vendorGallery" ? "data-[state=active]" : ""
                    }`}
                  onClick={() => setSelectedTab?.("vendorGallery")}
                >
                  Gallery
                </TabsTrigger>
              ) : (
                null
              )}

              {/* {role == '3' ? (
                <TabsTrigger
                  value="membershipCard"
                  className={`text-left justify-start w-0 p-0 TabsTrigger h-[60px] font-medium ${selectedTab === "membershipCard" ? "data-[state=active]" : ""
                    }`}
                  onClick={() => setSelectedTab?.("membershipCard")}
                >
                  Member Ship
                </TabsTrigger>
              ) : (
                null
              )} */}
            </TabsList>
          </Tabs>
        </div>
        <div>{renderComponent()}</div>
      </div>

    </>
  )
}

export default Account